import React from 'react';
import './styles.scss';

const AboutUsHomeFeelingSection = () => {
  return (
    <div className="__AboutUsHomeFeelingSection">
      <div className="position-relative __youtube-video-wrapper">
        <iframe
          src="https://player.vimeo.com/video/531885107?title=0&amp;byline=0&amp;portrait=0&amp;speed=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
          className="position-absolute"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="Urbain - Stay Delighted"
        ></iframe>
      </div>
      <div className="__my-container-v2 d-lg-flex font_lato justify-content-between flex-column">
        <div className="row justify-content-center mb-5">
          <h4 className="__title font_montserrat font-weight-mediam-bold __primary-text-color">How We See Hospitality</h4>
        </div>
        <div className="row justify-content-center">
          <div className="d-flex flex-column justify-content-between __heading-section-wrapper pr-sm-5">
            <h4 className="__title font_montserrat font-weight-mediam-bold __primary-text-color">
              You know that feeling when you get home at the end of a long day, kick off your shoes, pour a glass of your favorite, flop on the
              comfiest part of the couch, and flip on your show, or maybe just close your eyes for a few?
            </h4>
            <div className="__border"></div>
            <p className="__blog-section">
              When was the last time you had that feeling on the road? Travel is exciting. It's exhilarating to step out of your{' '}
              <span className="text-nowrap">day-to-day</span> and explore a new place. And yet, it can also be uncomfortable, uncertain, and{' '}
              <span className="text-nowrap">stressful-everything</span> you're looking to get away from!
            </p>
          </div>
          <div className="__blog-section-wrapper pl-lg-5">
            <p className="__blog-section">
              At Urbain, hospitality is about even more than being welcoming and having a "passion" for service. It's about giving our guests the
              warmth and comfort of home—a place where you aren't some stranger in some strange town. It’s about minding all the details, so you’re
              free to let your mind wander. It’s about making sure you’re safe and secure, so you can rest easy after a busy day of doing things you
              actually want to do. It’s about knowing exactly where to find the perfect dog park, coolest international grocery store, tastiest
              neighborhood pastry shop, or the nicest champagne flutes in the cabinet.
            </p>
            <p className="__blog-section">
              Urbain is about creating the relaxation and familiarity of home, as you revel in the excitement of discovering and exploring a new
              destination. So feel free to flop on the comfy part of the couch at the end of the day, without the stress of wondering where to find
              the remote control, or the discomfort of squeezing into that cramped urban hotel room. Pack your dancing shoes and your house slippers.
              Be at home. Everywhere.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUsHomeFeelingSection;
